import { render } from "./qualitaTask.vue?vue&type=template&id=1c072760&ts=true"
import script from "./qualitaTask.vue?vue&type=script&lang=ts"
export * from "./qualitaTask.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__